import { io } from 'socket.io-client';
import { getBackendUrl } from './baseUrl';

const backendUrl = getBackendUrl();

const socket = io(backendUrl, {
  path: '/socket.io',
  transports: ['websocket', 'polling'],
  autoConnect: true,
  withCredentials: true
});

export default socket;
